var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.523 2.62C0 3.649 0 4.993 0 7.68v8.64c0 2.688 0 4.032.523 5.06a4.8 4.8 0 0 0 2.098 2.097C3.648 24 4.99 24 7.68 24h8.64c2.688 0 4.032 0 5.06-.523a4.8 4.8 0 0 0 2.097-2.098C24 20.352 24 19.01 24 16.32V7.68c0-2.688 0-4.032-.523-5.06A4.8 4.8 0 0 0 21.379.524C20.352 0 19.01 0 16.32 0H7.68C4.992 0 3.648 0 2.62.523A4.8 4.8 0 0 0 .524 2.621Zm18.925 6.03a1.2 1.2 0 1 0-1.697-1.698L9.6 15.103l-3.351-3.351a1.2 1.2 0 1 0-1.698 1.696l4.2 4.2a1.2 1.2 0 0 0 1.697 0l9-9Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckbox;